import { Button } from '@wheely/ui-kit';
import React from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { Car } from '@/modules/car/model';
import { TUpdateCurrentVehicleForm } from '@/modules/driver/model/driver';
import { BottomButtons } from '@/shared/view/BottomButtons';
import { DataField } from '@/shared/view/DataField';
import { StepLayout } from '@/shared/view/StepLayout';
import { Icon } from '@src-common/view/components/Icon';

import { VehicleSelector } from './components/VehicleSelector';
import s from './styles.module.css';

type IEditCurrentVehicleViewProps = {
  control: Control<TUpdateCurrentVehicleForm>;
  isSubmitting?: boolean;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  onNavigateBack: () => void;
  vehicles: Car[];
};

const EditCurrentVehicleView = ({
  onSubmit,
  control,
  isSubmitting,
  onNavigateBack,
  vehicles,
}: IEditCurrentVehicleViewProps) => {
  const intl = useIntl();

  return (
    <StepLayout
      hideProgress={true}
      title={intl.formatMessage({
        defaultMessage: 'Current vehicle',
        id: 'Gnx/o3',
        description: 'Edit current vehicle screen: title',
      })}
      onClickBack={onNavigateBack}
    >
      <main className={s.wrapper}>
        <Link to="/vehicles" className={s.manageVehiclesLink}>
          <DataField
            title={
              <FormattedMessage
                defaultMessage="Manage vehicles"
                id="lplJAs"
                description="Edit current vehicle screen: Manage vehicles links"
              />
            }
          >
            <div className={s.iconWrapper}>
              <Icon icon={'chevron-to-end'} className={s.linkIcon} />
            </div>
          </DataField>
        </Link>

        <form onSubmit={onSubmit} className={s.form}>
          <div className={s.formFields}>
            <div className={s.scrollableContainer}>
              <VehicleSelector name="carId" control={control} vehicles={vehicles} />
            </div>
          </div>

          <BottomButtons className={s.formButtons}>
            <Button type="submit" disabled={isSubmitting} className={s.mainButton}>
              <FormattedMessage
                defaultMessage="Change vehicle"
                id="Q7Ha2N"
                description="Edit current vehicle screen: save button"
              />
            </Button>
          </BottomButtons>
        </form>
      </main>
    </StepLayout>
  );
};

export type { IEditCurrentVehicleViewProps };
export { EditCurrentVehicleView };
